import React, { useContext } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { LanguageContext } from "../LanguageContext"; // Import LanguageContext
import "./Footer.css";

const Footer = () => {
  const { language } = useContext(LanguageContext); // Access current language
  const handleClick = () => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  };
  return (
    <footer>
      {/* Social Media Section */}
      <div className="social-media-section" aria-label="Social Media Links">
        <div className="social-media">
          <a href="#facebook" className="social-icon" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="#twitter" className="social-icon" aria-label="Twitter">
            <FaTwitter />
          </a>
          <a href="#instagram" className="social-icon" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="#youtube" className="social-icon" aria-label="YouTube">
            <FaYoutube />
          </a>
        </div>
      </div>

      {/* Bottom Links Section */}
      <div className="footer-bottom" aria-label="Footer Links">
        <div className="footer-left">
          <p>
            © {new Date().getFullYear()}{" "}
            <Link to="/" className="website-name">
              snapseedqrcodes.download
            </Link>{" "}
            •{" "}
            {language === "english"
              ? "All rights reserved."
              : "सर्वाधिकार सुरक्षित।"}
          </p>

        </div>
        <div className="footer-right">
        <Link to="/about" aria-label="About Us" onClick={handleClick}>
  {language === "english" ? "About Us" : "हमारे बारे में"}
</Link>

<Link to="/privacy-policy" aria-label="Privacy Policy" onClick={handleClick}>
  {language === "english" ? "Privacy Policy" : "गोपनीयता नीति"}
</Link>

<Link to="/terms" aria-label="Terms and Conditions" onClick={handleClick}>
  {language === "english" ? "Terms & Conditions" : "नियम और शर्तें"}
</Link>

<Link to="/contact" aria-label="Contact Us" onClick={handleClick}>
  {language === "english" ? "Contact Us" : "संपर्क करें"}
</Link>

          
          <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">
    Sitemap
  </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
